/* Bloomove — Minimum cart quantity (TOTAL) */
(() => {
  const MIN_QTY = 3;

  const SELECTORS = {
    checkoutButtons:
      'button[name="checkout"], button[type="submit"][name="checkout"], button[data-ref="checkout-button"], a[href^="/checkout"]',
    cartDrawer: 'cart-drawer',
    cartDrawerFooter: '.cart-drawer__footer, .cart-drawer__footer-container, .cart-drawer__footer color-scheme-1, .cart-drawer__footer.color-scheme-1, .cart-drawer__footer-wrapper',
    cartPage: 'form[action="/cart"]',
  };

  async function getCartCount() {
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!res.ok) return null;
      const cart = await res.json();
      return typeof cart.item_count === 'number' ? cart.item_count : null;
    } catch (e) {
      return null;
    }
  }

  function ensureMessage(container) {
    if (!container) return null;
    let msg = container.querySelector('.bm-mincart-msg');
    if (msg) return msg;

    msg = document.createElement('div');
    msg.className = 'bm-mincart-msg';
    msg.style.cssText =
      'margin-top:10px;font-size:14px;line-height:1.3;opacity:.95;';
    container.appendChild(msg);
    return msg;
  }

  function lockCheckout(root, locked, totalQty) {
    if (!root) return;

    // footer où injecter le message (drawer)
    const footer =
      root.querySelector('.cart-drawer__footer') ||
      root.querySelector('.cart-footer') ||
      root;

    const msg = ensureMessage(footer);

    const buttons = Array.from(root.querySelectorAll(SELECTORS.checkoutButtons));
    buttons.forEach((el) => {
      const isLink = el.tagName === 'A';
      if (locked) {
        el.setAttribute('aria-disabled', 'true');
        el.style.pointerEvents = 'none';
        el.style.opacity = '0.55';
        if (!isLink) el.disabled = true;
      } else {
        el.removeAttribute('aria-disabled');
        el.style.pointerEvents = '';
        el.style.opacity = '';
        if (!isLink) el.disabled = false;
      }
    });

    if (msg) {
      if (locked) {
        const remaining = Math.max(0, MIN_QTY - totalQty);
        msg.textContent =
          `Ajoutez encore ${remaining} culotte` +
          (remaining > 1 ? 's' : '') +
          ` pour valider votre pack (minimum ${MIN_QTY}).`;
      } else {
        msg.textContent = '';
      }
    }
  }

  async function applyRules() {
    const totalQty = await getCartCount();
    if (totalQty == null) return;

    const shouldLock = totalQty > 0 && totalQty < MIN_QTY;

    // Cart drawer
    const drawer = document.querySelector(SELECTORS.cartDrawer);
    if (drawer) lockCheckout(drawer, shouldLock, totalQty);

    // Cart page
    const cartPageForm = document.querySelector(SELECTORS.cartPage);
    if (cartPageForm) lockCheckout(document, shouldLock, totalQty);
  }

  function observeCartDrawer() {
    const drawer = document.querySelector(SELECTORS.cartDrawer);
    if (!drawer) return;

    const obs = new MutationObserver(() => applyRules());
    obs.observe(drawer, { childList: true, subtree: true, attributes: true });
  }

  // Intercepte aussi le click checkout au cas où (sécurité)
  function interceptCheckoutClicks() {
    document.addEventListener(
      'click',
      async (e) => {
        const target = e.target && e.target.closest && e.target.closest(SELECTORS.checkoutButtons);
        if (!target) return;

        const totalQty = await getCartCount();
        if (totalQty == null) return;

        const shouldLock = totalQty > 0 && totalQty < MIN_QTY;
        if (shouldLock) {
          e.preventDefault();
          e.stopPropagation();
          applyRules();
        }
      },
      true
    );
  }

  document.addEventListener('DOMContentLoaded', () => {
    applyRules();
    observeCartDrawer();
    interceptCheckoutClicks();

    // Recheck périodique léger (au cas où le thème ne déclenche pas de mutations attendues)
    setInterval(applyRules, 1500);
  });
})();
